export default [
  { value: 'opera', label: 'Opera' },
  { value: 'ballet', label: 'Ballet' },
  { value: 'musica', label: 'Musica' },
  { value: 'familiar', label: 'Familiar' },
  { value: 'zarzuela', label: 'Zarzuela' },
  { value: 'dance', label: 'Danza' },
  { value: 'conference', label: 'Conferencia' },
  { value: 'class', label: 'Taller o Clase' },
  { value: 'otros', label: 'Otros' },
];



// WEBPACK FOOTER //
// ./src/utils/ProductionTypes.js